export default __webpack_public_path__ + "static/media/cp_geo_bd.e9ac60d9.svg";